<template>
  <div class="index">
   <div class="index_top">
    <p class="index_top_txt index_top_txt1">量势新能源</p>
    <p class="index_top_txt index_top_txt2 mt40">新能源  新生活</p>
   </div>
   <div class="index_content_1">
     <ul class="index_content_1_cot clear_fd">
       <li class="index_content_1_cot_li">
         <img src="../assets/kuaichong.png" alt="">
         <p class="mt20 fz_20">自营</p>
       </li>
       <li class="index_content_1_cot_li">
         <img src="../assets/zhuanshu.png" alt="">
         <p class="mt20 fz_20">联营</p>
       </li>
       <li class="index_content_1_cot_li">
         <img src="../assets/dingzhi.png" alt="">
         <p class="mt20 fz_20">代建</p>
       </li>
       <li class="index_content_1_cot_li">
         <img src="../assets/daiyunwei.png" alt="">
         <p class="mt20 fz_20">代运维</p>
       </li>
     </ul>
   </div>
   <div class="index_content_2">
   </div>
   <div class="index_content_3">
     <div class="index_content_3_txt clear_fd">
       <div class="index_content_3_txt_left">
         <p>充电服务</p>
         <p class="mt30">安全·专业·高效</p>
       </div>
       <div class="index_content_3_txt_right">
         <p class="mt20">10余年打磨标准化充电运营流程</p>
         <p class="mt10">保证用户充电安全和用户体验</p>
       </div>
     </div>
      <ul class="clear_fd index_content_3_cot_cot">
         <li class="index_content_3_cot_li" :class="index != (numList.length-1) ? 'border_r': ''" v-for="(item,index) in numList" :key="index">
           <p class="fz_44 numMove">{{item.num}}</p>
           <p class="mt40 fz_20">{{item.name}}</p>
           <p class="mt5">{{item.unit}}</p>
         </li>
      </ul>
   </div>
    <div class="index_content_4">
      <p class="index_content_4_txt1">充电场站集成商</p>
      <p class="index_content_4_txt2 mt35">深耕于充电行业10年+，旗下2家国家高新技术企业，60+技术和管理人员专注研究充电站的开发、生产和经营。</p>
      <p class="index_content_4_txt2 mt15">专利持续增加中…</p>
      <p class="index_content_4_txt3 mt50">
        <span class="index_content_4_txt3_sjx"></span>
      </p>
    </div>
<!--   <div class="index_content_4">-->
<!--     <p class="index_content_4_txt1">充电解决方案</p>-->
<!--     <p class="index_content_4_txt2 mt35">专注于“互联网”+“充电”打造</p>-->
<!--     <p class="index_content_4_txt2 mt15">定义充电服务运营标准</p>-->
<!--     <p class="index_content_4_txt3 mt50">-->
<!--       <span class="index_content_4_txt3_sjx"></span>-->
<!--     </p>-->
<!--   </div>-->
   <div class="index_content_5">
     <ul class="clear_fd">
       <li class="index_content_5_li img_5_li_1">
         <div class="index_content_5_li_zz">
           <img src="../assets/zz_wuliu.png" alt="">
           <p class="mt40">物流</p>
         </div>
       </li>
       <li class="index_content_5_li img_5_li_2">
         <div class="index_content_5_li_zz">
           <img src="../assets/zz_gongjiao.png" alt="">
           <p class="mt40">公交</p>
         </div>
       </li>
       <li class="index_content_5_li img_5_li_3">
         <div class="index_content_5_li_zz">
           <img src="../assets/zz_wangyue.png" alt="">
           <p class="mt40">网约车</p>
         </div>
       </li>
       <li class="index_content_5_li img_5_li_4">
         <div class="index_content_5_li_zz">
           <img src="../assets/zz_huanwei.png" alt="">
           <p class="mt40">环卫</p>
         </div>
       </li>
     </ul>
   </div>
   <div class="index_content_6 clear_fd">
     <div class="index_content_6_left">
       <div class="index_content_6_left_cot">
         <p class="index_content_6_left_cot_txt1">里程碑</p>
         <p class="index_content_6_left_cot_txt2 mt30"><span class="mr30">砥砺前行</span><span>不忘初心</span></p>
         <p class="index_content_6_left_cont_fenge mt50"></p>
         <p class="index_content_6_left_cot_txt3 mt50">从自建充电到联营充电</p>
         <p class="index_content_6_left_cot_txt3 mt10">技术创新充电服务体验升级</p>
       </div>
     </div>
     <div class="index_content_6_right">
       <div class="index_content_6_right_cot">
         <div class="index_nav_ul pr40">
           <div :class="selectTab == item.id ? 'ml50 index_nav_li posr index_nav_li_select' : 'ml50 index_nav_li posr'" v-for="(item,index) in tabList" :key="index" @click="cutNav(item)">
             <p :class="'index_nav_li_txt '+ (item.history ? 'color_666': 'color_999')">{{item.name}}
              <span :class="selectTab == item.id ? 'index_wrie' : 'hide'"></span>
             </p>
           </div>
         </div>
         <div :class="'index_nav_cot mt20 '+ (selectTabHis ? 'color_333' : 'color_999')">
           <p class="index_nav_cot_txt" v-for="(item,index) in selectList" :key="index">{{item}}</p>
         </div>
       </div>
     </div>
   </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      tabList: [
        {
          id: 0,
          name: "2016",
          history: true,
          list: [
            "2月，60kW充电桩产品型式试验通过",
            "3月，智能互联网充电云平台多场景联调并迭代完成"
          ]
        },
        {
          id: 1,
          name: "2017",
          history: true,
          list: [
            "9月，京东华南第一物流园（广州）充电站投入运营，开启与京东物流合作"
          ]
        },
        {
          id: 2,
          name: "2018",
          history: true,
          list: [
            "2月，武汉子公司成立",
            "3月，广州美都装饰城网约车站点上线",
            "7月，第一个公交充电站点上线",
            "12月，落地全国集中式充电站点达到20个"
          ]
        },
        {
          id: 3,
          name: "2019",
          history: true,
          list: [
            "12月，完成5个核心城市1000个充电桩布局，满足10000辆商用车充电需求"
          ]
        },
        {
          id: 4,
          name: "2020",
          history: true,
          list: [
            "12月，完成10个核心城市2000个充电桩布局，满足20000辆商用车充电需求",
            "通过收购整合原小型私人充电桩运营企业"
          ]
        },
        {
          id: 5,
          name: "2021",
          history: true,
          list: ["1月，拓展上下游产业链"]
        },
        {
          id: 6,
          name: "2024",
          history: true,
          list: ["持有和在建的充电站产品/资产超过50座，分布于大湾区和海南等地"]
        },
      ],
      selectTabHis: true,
      selectTab: 0,
      selectList: [
        "2月，60kW充电桩产品型式试验通过",
        "3月，智能互联网充电云平台多场景联调并迭代完成"
      ],
      numList: [
        { num: "60+", name: "工程师", unit: "(位)" },
        { num: "2,000+", name: "充电终端", unit: "(支)" },
        { num: "80+", name: "专利", unit: "(项)" },
        { num: "120,000", name: "电力容量储备", unit: "(kVA)" }
      ]
    };
  },
  mounted: function() {
    var that = this;
    var firstDo = 1;
    window.addEventListener("scroll", function() {
      // var scrollTop = document.documentElement.scrollTop;
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 800 && firstDo == 1) {
        firstDo = 2;
        var numArr = [];
        var tArr = [];
        for (let i = 0; i < that.numList.length; i++) {
          var num = that.numList[i].num;

          var size = parseInt(num / 40); //  调节数字动的速度
          var numObj = { num: num, size: size };
          numArr[i] = numObj;
          // that.numList[i].num = 0;
          that.numList[i].num = numArr[i].num;
          // tArr[i] = setInterval(function() {
          //   that.numList[i].num += numArr[i].size;
          //   if (that.numList[i].num >= numArr[i].num) {
          //     that.numList[i].num = numArr[i].num;
          //     clearInterval(tArr[i]);
          //   }
          // }, 10);
        }
      }
      if (scrollTop < 100 && firstDo != 1) {
        firstDo = 1;
      }
    });
  },
  methods: {
    //  方法
    cutNav: function(item) {
      this.selectTab = item.id;
      this.selectTabHis = item.history;
      this.selectList = item.list;
    }
  }
};
</script>

<style>
.index_top {
  height: 610px;
  background-image: url("../assets/index_banner.png");
  background-size: 100% 100%;
}
.index_top_txt {
  text-align: center;
  color: #ffffff;
}
.index_top_txt1 {
  font-size: 68px;
  padding-top: 150px;
  letter-spacing: 25px;
}
.index_top_txt2 {
  font-size: 39px;
  letter-spacing: 15px;
}
.index_content_1 {
  height: 160px;
  position: relative;
}
.index_content_1_cot {
  position: absolute;
  box-shadow: 0 0 5px 2px #f0f0f0;
  top: -80px;
  left: 20%;
  right: 20%;
  background-color: #01203d;
}
.index_content_1_cot_li {
  float: left;
  text-align: center;
  padding: 55px 0px;
  width: 25%;
}
.index_content_1_cot_li img{
  width: 100px;
  height: 100px;
}
.index_content_1_cot_li p{
  color: #fff;
}

.index_content_2 {
  background-image: url("../assets/index_bg_2.png");
  margin: 75px 80px;
  height: 87px;
  background-size: 100% 100%;
}

.index_content_3 {
  height: 780px;
  background-image: url("../assets/index_bg_3.png");
  background-size: 100% 100%;
}
.index_content_3_txt {
  padding: 100px 20%;
  color: #ffffff;
}
.index_content_3_txt_left {
  float: left;
  font-size: 33px;
}
.index_content_3_txt_right {
  float: right;
  text-align: right;
  font-size: 27px;
}
.index_content_3_cot_cot {
  margin: 50px 20% 0 20%;
  padding: 60px 0;
  color: #ffffff;
  background: rgba(12, 75, 119, 0.5);
}
.index_content_3_cot_li {
  float: left;
  width: 25%;
  text-align: center;
  box-sizing: border-box;
}
.border_r {
  border-right: 1px solid #ffffff;
}
.fz_44 {
  font-size: 44px;
}

.index_content_4 {
  background-image: url("../assets/index_bg_4.png");
  background-size: 100% 100%;
  text-align: center;
  padding: 120px 0;
}
.index_content_4_txt1 {
  font-size: 34px;
  color: #333333;
  font-weight: bold;
}
.index_content_4_txt2 {
  font-size: 26px;
  color: #666;
}
.index_content_4_txt3_sjx {
  display: inline-block;
  box-sizing: border-box;
  width: 24px;
  height: 18px;
  background: url("../assets/sjx.png");
}

.index_content_5_li {
  float: left;
  width: 25%;
  height: 530px;
  box-sizing: border-box;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
}
.index_content_5_li:hover {
  background-size: 120% 120%;
  background-position: 10% 10%;
}
.img_5_li_1 {
  background-image: url("../assets/car_wuliu.png");
}
.img_5_li_2 {
  background-image: url("../assets/car_gongjiao.png");
}
.img_5_li_3 {
  background-image: url("../assets/car_wangyue.png");
}
.img_5_li_4 {
  background-image: url("../assets/car_huanwei.png");
}
.index_content_5_li_zz {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  color: #ffffff;
  text-align: center;
  padding-top: 210px;
  background-color: rgba(0, 0, 0, 0.5);
}

.index_content_6 {
  background-image: url("../assets/index_bg_6.png");
  margin: 75px 0;
}
.index_content_6_left {
  float: left;
  width: 40%;
  height: 403px;
  position: relative;
}
.index_content_6_left_cot {
  position: absolute;
  right: 0;
  width: 403px;
  height: 403px;
  border: 3px solid #61d481;
  box-sizing: border-box;
  padding: 35px;
}
.index_content_6_left_cont_fenge {
  width: 48px;
  height: 8px;
  /* background: #61d481; */
  background: linear-gradient(to right, #5bcb89, #2b88cd);
}
.index_content_6_left_cot_txt1 {
  font-size: 35px;
  color: #333333;
  font-weight: bold;
}
.index_content_6_left_cot_txt2 {
  font-size: 29px;
  color: #666666;
}
.index_content_6_left_cot_txt3 {
  font-size: 27px;
  color: #666666;
}
.index_content_6_right {
  float: left;
  margin-top: 70px;
}
.index_content_6_right_cot {
  background-color: rgba(200, 200, 200, 0.1);
  padding: 50px 15px 15px 15px;
  min-height: 265px;
}

.index_nav_ul::after {
  content: "";
  display: block;
  clear: both;
}
.index_nav_li {
  float: left;
  position: relative;
  padding: 15px;
}
.index_nav_li_select {
  color: #3c9eb6;
}
.index_nav_li_txt {
  position: relative;
  font-size: 24px;
}
.index_wrie {
  position: absolute;
  height: 2px;
  left: 0;
  right: 0;
  bottom: -10px;
  background: linear-gradient(to right, #5bcb89, #2b88cd);
}
.index_nav_cot {
  font-size: 23px;
}
.index_nav_cot_txt {
  padding-left: 75px;
  position: relative;
  height: 46px;
  line-height: 46px;
}
.index_nav_cot_txt::before {
  content: "";
  width: 5px;
  height: 5px;
  background-color: #333333;
  border-radius: 50%;
  position: absolute;
  left: 65px;
  top: 21px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue